var compareDevices = function compareDevices(_ref, _ref2) {
  var _ref$device = _ref.device,
    area = _ref$device.area,
    sortOrder = _ref$device.gui.sortOrder;
  var _ref2$device = _ref2.device,
    otherArea = _ref2$device.area,
    otherSortOrder = _ref2$device.gui.sortOrder;
  if (sortOrder !== otherSortOrder) {
    return sortOrder - otherSortOrder;
  }
  if (area < otherArea) {
    return -1;
  }
  if (area > otherArea) {
    return 1;
  }
  return 0;
};

export { compareDevices };
